module.exports = __webpack_public_path__ + "img/lock-selection.851e07a3.svg";